/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 1,
  scroll: 1,
});
jQuery("#nav2").slide({
  mainCell: ".img-group",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 3,
  scroll: 5,
});

new Swiper(".sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },

  loop: true,
});
new Swiper(".sp-swiper2", {
  speed: 5000,
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 1,
  },
  slidesPerView: 3,

  loop: true,
});
var thumbsp = new Swiper("#thumbs-p", {
  direction: "vertical",
  spaceBetween: 9,
  slidesPerView: 3,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper = new Swiper("#swiper-p1", {
  thumbs: {
    swiper: thumbsp,
  },
  on: {
    slideChange: function (e) {
      $("#sp-color .option")
        .eq(e.activeIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  spaceBetween: 20,
});

let spImgList = [
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/black.png?v=1721793645",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/ewd.png?v=1721793646",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/pink.png?v=1721793646",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/xong.png?v=1721793646",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/shenz.png?v=1721793646",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p1-s.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p2-s.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p3-s.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p4-s.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p5-s.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p1-l.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p2-l.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p3-l.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p4-l.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-p5-l.png",
];
let bannerList = [
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-img1.jpg?v=1721786490",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-img2.jpg?v=1721786489",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-b1.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-b2.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-b3.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-b4.png",
  "https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20240724-b5.png",
];
function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    // preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            222 * $("div#root").css("zoom") -
            138 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();



  let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let amount = $('#sp-size div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == amount)[0]
}
  function changePrice(){
          let num = $('#calcNumber').val()
          let price = (getCur().price * num / 100).toFixed(2)
          let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      price = (price + '').replace('.', ',')
  compare = (compare + '').replace('.', ',')
          $('#sp_price1').html(price)
          $('#sp_price2').html(compare)
          let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
          $(".product-part .sp-brand p span").html(off_font );
        }
// let sp_price1 = 49.99;
// let sp_price2 = 119.99;

// function calcTotal(price, num) {
//   let result = Number(price) * Number(num);
//   return result.toFixed(2);
// }

$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice()
  }
  // $("#sp_price1").html(calcTotal(sp_price1, input.value));
  // $("#sp_price2").html(calcTotal(sp_price2, input.value));
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
   changePrice()
  // $("#sp_price1").html(calcTotal(sp_price1, input.value));
  // $("#sp_price2").html(calcTotal(sp_price2, input.value));
});
  $('.sp-buynow').click(function(){
          let num = $('#calcNumber').val()
          window.location.href = '/cart/' + getCur().id + ':' + num
        })
$(function () {
  // style选项
    let typeOptions = $('#sp-color .option')
    // 切换选项
    typeOptions.click(function () {
      let sizeOptions = $("#sp-size .option.active").index();
      let colorOptions = $(this).index();
      if(colorOptions==0&&sizeOptions==3){
        $("#sp-size .option")
        .eq(2)
        .addClass("active")
        .siblings()
        .removeClass("active");
      }
      if(colorOptions>0&&sizeOptions==2){
        $("#sp-size .option")
        .eq(3)
        .addClass("active")
        .siblings()
        .removeClass("active");
      }
    })
  $(".option").click(function () {
    const isDisabled = $(this).hasClass("disbled");
       if(isDisabled) {
        return;
      }
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
     changePrice()
    // style选项

    let colorOptions = $("#sp-color .option.active").index();
    let sizeOptions = $("#sp-size .option.active").index();
    console.log(sizeOptions)
    swiper.slideTo(colorOptions);
    if (sizeOptions == 0) {
      $(".sp-img-more1").show();
      $(".sp-img-more").hide();
      $(".sp-img-more2").hide();
      $(".sp-img-more3").hide();
      $(".sp-img-more4").hide();
      $(".sp-img-more5").hide();
      
    } else if(sizeOptions == 1) {
      $(".sp-img-more1").hide();
      $(".sp-img-more").hide();
      $(".sp-img-more5").show();
      $(".sp-img-more2").show();
      $(".sp-img-more3").hide();
      $(".sp-img-more4").hide();
      
    } else {
      $(".sp-img-more1").hide();
      $(".sp-img-more5").hide();
      $(".sp-img-more").show();
      $(".sp-img-more2").show();
      $(".sp-img-more3").show();
      $(".sp-img-more4").show();
      
      
    }
    if(colorOptions==0){
      $("#sp-size .option")
        .eq(3)
        .addClass("disbled")
        .siblings()
        .removeClass("disbled");
    }else{
      $("#sp-size .option")
        .eq(2)
        .addClass("disbled")
        .siblings()
        .removeClass("disbled");
    }
  });
  $(".sp-img-more5").hide();
  $(".sp-img-more3").hide();
  // style选项
  // // 处理加入购物车事件
  // function handleAddToCart(num) {
  //   if (num > 0) {
  //     $("#cardNum").html(num).show();
  //     $(".sp-top-btn").addClass("sp-high");
  //     $(".sp-top-btn span").html("Check out");
  //     $(".sp-header-top .sp-cart").addClass("on");
  //   } else {
  //     $("#cardNum").html(0).hide();

  //     $(".sp-top-btn").removeClass("sp-high");
  //     $(".sp-top-btn span").html("Buy now");
  //     $(".sp-header-top .sp-cart").removeClass("on");
  //   }
  // }
  // handleAddToCart(0);

  // 购物车加购动效
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });
  if(window.cartCount > 0){
    $(".sp-header-top .sp-cart .num").show();
  }




  
  $(".product-part .cart-btn").click(function () {
     var data = {
      id: getCur().id,
        quantity: $('#calcNumber').val(),
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });
    let sizeOptions = $("#sp-size .option.active").index();

    // var img = $(".product-part .p-img");
    let addIndex = 1
    if(sizeOptions == 0 ){
      addIndex = 1
    }else if(sizeOptions == 1){
      addIndex = 5
    }else{
      addIndex = 3
    }
    var img = $(`.product-part .sp-swiper .swiper-slide-active .sp-img-more${addIndex}`);

    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      background: "#e7e9ef",
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top:
          finish[0].offsetTop + finish.height() / 2 + $(".time-part").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });
});
